module.exports = __webpack_public_path__ + "media/src/images/favicons/apple-touch-icon-167x167-40b1f67e79fe7f466a0ce540f4d58c45.png";